import React from 'react';

var HeaderRightButtons = React.createClass({
  handlePreviewClick: function(){
    this.props.showPreview();
  },
  handleEditClick: function(){
    // this.props.editTheme(this.props.data["name"].split("/")[1], this.props.data["name"].split("/")[0]);
    alert("Coming soon");
  },
  handleSourceClick: function(){
    this.props.editTheme(this.props.data["name"].split("/")[1], this.props.data["name"].split("/")[0]);
  },
  handleBrowseClick: function(){
    this.handleSourceClick();
  },
  render: function(){
    var aquisitions = this.props.aquisitions;
    return(
        <div className="content__col content__col--right"> 
            <div className="site__nav">
              <ul>
                { this.props.libName === "Shared with me" || this.props.libName === "Pending Transfers" ?
                  <li onClick= {this.handlePreviewClick} className ="tooltip__container"><a href= "javascript:void(0)"><i className ="fa fa-eye"> </i> <span>Preview</span><span className ="tooltip tooltip--top">Preview</span></a></li>
                  : null }
                {this.props.libName != "Shared with me" && this.props.type != "VIEWLAYOUT" && this.props.libName != "Pending Transfers" ?
                  <li onClick = {this.handleEditClick} className ="tooltip__container"><a href="javascript:void(0)"><i className="fa fa-pencil"> </i> <span>Edit</span><span className ="tooltip tooltip--top">Edit</span></a></li>
                  : null }
                { this.props.libName != "Shared with me" && this.props.libName != "Pending Transfers" ?
                  <li onClick = {this.handleSourceClick} className ="tooltip__container"><a href="javascript:void(0)"><i className ="fa fa-code"> </i> <span>Source Code</span><span className ="tooltip tooltip--top">Source Code</span></a></li>
                  : null  }
                {/*this.props.libName !== "Shared with me" ?
                  <li onClick = {this.handleBrowseClick} className ="tooltip__container"><a href="javascript:void(0)"><i className ="fa fa-code"> </i> <span>Browse</span><span className ="tooltip tooltip--top">Browse</span></a></li>
                  : null */}
                {this.props.libName === "Pending Transfers"? 
                    <li onClick = {this.handleBrowseClick} className ="tooltip__container"><a href="javascript:void(0)"><i className ="fa fa-code"> </i> <span>Browse</span><span className ="tooltip tooltip--top">Browse</span></a></li>
                    : null }
              </ul>
            </div>
        </div>
    );
  }
});

export {HeaderRightButtons};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/HeaderRightButtons.jsx
 **/